// uiarc: `useToday` (calendar/date-range-picker). Takvimlerin "bugün"ü tek yerden gelir; uiarc tarayıcı saatine
// bakar, burada tesis takvim günü (`todayAsDateInput`, Europe/Istanbul; AGENTS.md §5) kullanılır. Gün dönümünde,
// sekmeye dönünce ve pencere odak alınca yeniden okunur.
import { useMemo, useSyncExternalStore } from 'react'
import { dateInputToLocalDate } from '@/lib/calendar-date'
import { todayAsDateInput } from '@/lib/format'

/** Gün dönümünü kaçırmamak için dakikada bir bakar (zamanlayıcı uyku/saat değişiminden etkilenmez). */
const subscribeToday = (notify: () => void) => {
  const timer = window.setInterval(notify, 60_000)
  const onVisible = () => {
    if (document.visibilityState === 'visible') notify()
  }
  document.addEventListener('visibilitychange', onVisible)
  window.addEventListener('focus', notify)
  return () => {
    window.clearInterval(timer)
    document.removeEventListener('visibilitychange', onVisible)
    window.removeEventListener('focus', notify)
  }
}

/** Bugünün tesis takvim günü, yerel gece yarısı `Date` olarak (takvim bileşenleri yerel alanlarla çalışır). */
export function useToday(): Date | undefined {
  const key = useSyncExternalStore(
    subscribeToday,
    () => todayAsDateInput(),
    () => '',
  )
  return useMemo(() => dateInputToLocalDate(key), [key])
}
